









import Vue, { PropOptions } from 'vue';

export type FrameworkItem = Blok & {
  icon: BlokFieldAsset;
  label: string;
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<FrameworkItem>,
    showLabels: {
      type: Boolean,
    },
  },
});
